{
  "nl": {
    "constants": {
      "address": {
        "city": "Stad",
        "country": "Land",
        "number": "Nummer",
        "street": "Straat",
        "zip": "Postcode"
      },
      "crud": {
        "created_at": "Aangemaakt op",
        "deleted_at": "Verwijderd op",
        "updated_at": "Gewijzigd op"
      },
      "days": ["Zon", "Ma", "Di", "Woe", "Do", "Vr", "Za"],
      "languages": {
        "de": "Duits",
        "en": "Engels",
        "fallback_info": "Het lijkt erop dat dit bericht niet beschikbaar is in jouw taal. We gebruiken in plaats daarvan een bestaande vertaling in het {fallback_locale}.",
        "fr": "Frans",
        "nl": "Nederlands",
        "pl": "Pools",
        "pt": "Portugees"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "fr": "FR",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Metrisch",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "Januari",
        "Februari",
        "Maart",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "December"
      ],
      "profile_statuses": {
        "active": "Actief",
        "added": "Niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd",
        "invited_at": "Uitgenodigd"
      },
      "profile_statuses_descriptive": {
        "active": "Laatste keer actief op het platform: {session_ended_at}",
        "added": "Nog niet uitgenodigd",
        "blocked": "Gedeactiveerd",
        "discarded": "Verwijderd",
        "invited": "Uitgenodigd maar nog niet aangemeld",
        "invited_at": "Uitgenodigd {invited_at}. Nog niet aangemeld"
      },
      "profile_titles": {
        "dr": "Dokter",
        "mr": "Heer",
        "mrs": "Mevrouw",
        "professor": "Professor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Dagen",
        "months": "Maanden",
        "weeks": "Weken"
      },
      "time_units_count": {
        "days": "geen dag | dag | dagen",
        "months": "geen maand | maand | maanden",
        "weeks": "geen week | week | weken"
      },
      "timezones": {
        "America/Chicago": "Amerika/Chicago",
        "America/Denver": "Amerika/Denver",
        "America/Los_Angeles": "Amerika/Los Angeles",
        "America/New_York": "Amerika/New York",
        "Europe/Brussels": "Europa/Brussel",
        "Europe/Lisbon": "Europa/Lissabon",
        "Europe/London": "Europa/Londen",
        "Europe/Madrid": "Europa/Madrid"
      },
      "wind_orientations": {
        "east": "Oostelijk",
        "north": "Noord",
        "northeast": "Noordoost",
        "northwest": "Noordwest",
        "select": "Selecteer Oriëntatie",
        "south": "Zuid",
        "southeast": "Zuidoost",
        "southwest": "Zuidwest",
        "west": "Westelijk"
      }
    }
  }
}
